import * as Const from '../../shared/constants';

import { Component, OnInit, ViewChild } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';

//Modelos e Interfaces
import { ICliente } from 'src/app/interfaces/cliente';
import { IListaOpciones } from 'src/app/interfaces/lista-opciones';
import { IPreparaciones } from 'src/app/interfaces/preparaciones';

// Servicios
import { ClientesService } from 'src/app/services/datos/clientes.service';
import { PreparacionesService } from 'src/app/services/datos/preparaciones.service';

// Librerias
import FuncLib from 'src/app/providers/funcionesLib';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-preparaciones-incidencias-list',
  templateUrl: './preparaciones-incidencias-list.component.html',
  styleUrls: ['./preparaciones-incidencias-list.component.scss'],
})
export class PreparacionesIncidenciasListComponent implements OnInit {

  // Librería de funciones
  public funcLib: FuncLib = new FuncLib();

  // Usar constantes en el template
  Const = Const;

  loading: boolean = false;
  textoDestacado: string = '';
  public strBuscarTodo: string = '';

  messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: 'Total',
    selectedMessage: 'seleccionado',
  };

  prepList: IPreparaciones[] = [];
  clientesList: ICliente[] = [];

  rows: IPreparaciones[] = [];
  temp: any[] = [];

  columns = [];
  ColumnMode = ColumnMode;

  cliSeleccionado: string = '';

  public summaryPosition: string =
    localStorage.getItem('summaryPosition') || 'bottom';
  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  @ViewChild(PreparacionesIncidenciasListComponent) table:
    | PreparacionesIncidenciasListComponent
    | any;

  constructor(
    public preparacionesSrv: PreparacionesService,
    private clientesSrv: ClientesService
  ) { }

  ngOnInit(): void {
    this.getClienteList();
    this.getListaPrep();
  }

  getClienteList() {
    this.loading = true;
    this.clientesSrv.getLista().subscribe((resp) => {
      this.loading = false;
      this.clientesList = resp.data.filter(
        (cliente: { archivado: boolean }) => !cliente.archivado
      );
    });
  }

  getListaPrep() {
    const opcionesList: IListaOpciones = {};
    opcionesList.id_cliente = parseInt(this.cliSeleccionado);
    opcionesList.recogidaIncidencia = '1';

    this.loading = true;
    this.preparacionesSrv.getListaFiltrada(opcionesList).subscribe((resp) => {
      console.log(resp);
      this.loading = false;
      this.prepList = resp.data;
      this.rows = this.prepList;
      this.temp = [...this.prepList];
    });
  }

  // Búscar y filtrar

  filtro(val: string, campo: string) {
    // filter our data
    const temp = this.temp.filter(function (d) {
      if (d[campo]) return d[campo].toLowerCase().indexOf(val) !== -1 || !val;
      return !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.prepList;
  }

  buscar(event: any, campo: string) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    this.filtro(txt, campo);
  }

  buscarTodo(event: any) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    // Marcar el texto destacado
    this.textoDestacado = txt;

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.prepList;
  }

  dblclickCampo(valor: any) {
    this.strBuscarTodo = String(valor);
    const txt = valor.toLowerCase() ?? '';
    this.buscaGlobal(txt);
  }

  buscaGlobal(txt: string) {
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    // Marcar el texto destacado
    this.textoDestacado = txt;

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.prepList;
  }

  limpiaBusca() {
    this.strBuscarTodo = '';
    this.buscaGlobal('');
    const buscaTodoInput = document.getElementById('buscaTodo');
    buscaTodoInput?.focus();
  }

  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr); // convertir el valor a número
  }

  // Filtros

  onClienteSelect(id: string) {
    this.cliSeleccionado = id;
    this.getListaPrep();
  }

  // AUX

  goCampanya(row: any) {
    alert('__goCampanya: ' + JSON.stringify(row.campanya));
  }

  public sumaCeldas(cells: any[]) {
    // Devuelve la suma de la columna, formateada y sin decimales
    const filteredCells = cells.filter((cell) => !!cell);
    const sum: number = filteredCells.reduce(
      (accumulator, currentValue) => accumulator + parseFloat(currentValue),
      0
    );
    // return sum.toLocaleString('es');
    return sum.toLocaleString('de-DE');
  }

  // EXPORTAR A EXCEL
  exportToExcel(): void {
    const fileName = `Preparaciones-${new Date().toISOString()}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(this.rows);
    const workbook = XLSX.utils.book_new();

    // Forzar valores numéricos en las columnas Xlsx
    Object.entries(worksheet).forEach(([cell, cellObj]) => {
      if (!cell.startsWith('!') && !isNaN(cellObj.v) && cellObj.v !== '') {
        cellObj.v = Number(cellObj.v);
        cellObj.t = 'n';
      }
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName);
  }
}
